const Lightbox = (() => {
  /*
  * 
  *   contenitore:          [class="js-lightbox"], [id="@id"]
  *   modale:               [class="js-lightbox-inner"]
  *   bottone di chiusura:  [class="js-lightbox-close"]
  *   links di apertura:    [data-lightbox="@id"]
  * 
  */
  const manager = {
    openButtons: document.querySelectorAll('[data-lightbox]'),
    containers: document.querySelectorAll('.js-lightbox'),
    instances: [],

    appendBodyListener: function (_) {
      const listener = () => {
        _.container.classList.remove('is-open')
        _.isOpen = false
        _.inner.removeEventListener('click', this.backgroundListener)
        _.hasBodyListener = false
        document.body.removeEventListener('click', _.bodyListener)
      }

      _.bodyListener = listener
      _.hasBodyListener = true
      document.body.addEventListener('click', _.bodyListener)
    },

    backgroundListener: function (e) {
      e.stopPropagation()
    },

    initInstances: function () {
      this.instances.forEach(_ => {
        if (_.isOpen) {
          this.appendBodyListener(_)
          _.inner.addEventListener('click', this.backgroundListener)
        }

        if (_.closeButtons) {
          _.closeButtons.forEach((closeButton) => {
            closeButton.addEventListener('click', () => {
              _.container.classList.remove('is-open')
              document.body.removeEventListener('click', _.bodyListener)
              _.inner.removeEventListener('click', this.backgroundListener)
              _.isOpen = false
            })
          })
        }
      })
    },

    init: function () {
      if (this.containers.length) {
        this.backgroundListener = this.backgroundListener.bind(this)
        this.appendBodyListener = this.appendBodyListener.bind(this)
        
        this.containers.forEach(container => {
          const inner = container.querySelector('.js-lightbox-inner')
          const id = container.getAttribute('id')
          const closeButtons = container.querySelectorAll('.js-lightbox-close')
          const isOpen = container.classList.contains('is-open')

          this.instances.push({
            container,
            inner,
            id,
            closeButtons,
            isOpen,
            bodyListener: null,
            hasBodyListener: false
          })
        })

        this.initInstances()

        if (this.openButtons.length) {
          this.openButtons.forEach(el => {
            const id = el.getAttribute('data-lightbox')
            el.addEventListener('click', () => {
              const instance = this.instances.find(_ => _.id == id)
              if (instance) {
                instance.container.classList.add('is-open')
                instance.isOpen = true
                setTimeout(() => {
                  instance.inner.addEventListener('click', this.backgroundListener)
                  this.appendBodyListener(instance)
                }, 50);
              }
            })
          })
        }
      }
    }
  }

  const init = () => {
    manager.init()
  }

  const getInstances = () => {
    return manager.instances
  }

  return {
    init,
    getInstances
  }
})()

export default Lightbox


// WEBPACK FOOTER //
// app/javascript/scripts/components/Lightbox.js